import {
  FETCH_QUESTIONS_FULFILLED,
  FETCH_QUESTIONS_PENDING,
  FETCH_QUESTIONS_REJECTED,
  QuestionsActionTypes,
  QuestionsState,
} from './types';

const initialState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  nbResult: 0,
};

export const reducer = (
  state: QuestionsState = initialState,
  action: QuestionsActionTypes,
) => {
  switch (action.type) {
    case FETCH_QUESTIONS_PENDING: {
      return {
        ...state,
        fetched: false,
        fetching: true,
      };
    }
    case FETCH_QUESTIONS_FULFILLED: {
      const { data, nbResult } = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: [...data[0]],
        nbResult: nbResult,
      };
    }
    case FETCH_QUESTIONS_REJECTED: {
      let error = action.payload;
      switch (error?.response?.status) {
        case 404:
          error = {
            title: error?.response?.data?.title,
            code: 404,
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: error,
        items: [],
        nbResult: 0,
      };
    }
    default:
      return state;
  }
};
export default reducer;
